import React from 'react';

interface Props {
  errorMessage: React.ReactNode;
}

export const FormError = ({ errorMessage }: Props) => {
  return <div>{errorMessage}</div>;
};
